import { yupResolver } from "@hookform/resolvers/yup";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Resolver, useForm } from "react-hook-form";

import { contentVideoSchema } from "../../../helpers";
import {
  DescriptionField,
  ImageField,
  TargetResellerLevelField,
  TitleField,
  TutorialFlagsField,
  VideoField
} from "./atoms";
import { VideoFormProps, VideoFormValues } from "./VideoForm.types";

import styles from "./VideoForm.module.scss";

const VideoForm = ({ formId, defaultValues, onSubmit }: VideoFormProps) => {
  const { handleSubmit, control } = useForm<VideoFormValues>({
    defaultValues,
    resolver: yupResolver(contentVideoSchema) as Resolver<any, any>
  });

  return (
    <form id={formId} className={styles.form} onSubmit={handleSubmit(onSubmit)}>
      <TitleField control={control} />

      <DescriptionField control={control} />

      <TargetResellerLevelField control={control} />

      <TutorialFlagsField control={control} />

      <div className={styles.form_twoInputsBlock}>
        <VideoField control={control} />
        <ImageField control={control} />
      </div>
    </form>
  );
};

export default VideoForm;
